<div class="screen-element control-showcase">
	<div class="title">{{title|uppercase}}</div>
	<!--<div class="dashboard-center">
		<div class="icon {{dashIcon}}"></div>
	</div>-->
	<div class="text">
		<div *ngFor="let t of text">
			<text-widget [text]="translator.tr(t)" [color]="'white'"></text-widget>
		</div>
	</div>
</div>